var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BCXMarkdown',{staticClass:"bc-messenger-bot",attrs:{"tag":"div","text":_vm.t('messenger.chat.bot_message_USERTYPE',{name: _vm.name})}})
}
var staticRenderFns = []

export { render, staticRenderFns }